import React, { useState } from 'react';
import { FloatButton, Popover, Typography, Input, Button, Form, message, Spin } from 'antd';
import ChatIcon from '@assets/icons/suggestion-box-icon.png';
import { LoadingOutlined } from '@ant-design/icons';

import { ISuggestionBoxParams } from 'services/interface';
import { sendEmail } from 'services/SendEmail';

import './styles.css';

const { Title } = Typography;
const { TextArea } = Input;

const antIcon = <LoadingOutlined style={{ fontSize: 30 }} spin />;

const SuggestionBox: React.FC = () => {
	const [form] = Form.useForm<ISuggestionBoxParams>();
	const [loading, setLoading] = useState(false);
	const [popoverOpen, setPopoverOpen] = useState(false);

	//reset form
	const handlePopoverOpenChange = (open: boolean) => {
		setPopoverOpen(open);
		if (open) {
			form.resetFields();
		}
	};

	const onFinish = async (values: ISuggestionBoxParams) => {
		try {
			setLoading(true);

			const emailContent = `
				Name: ${values.fname}
				\n
				Email: ${values.uemail}
				\n
				Subject: ${values.msg_subject}
				\n
				Feedback: ${values['textarea-172']}
				\n
				This feedback was submitted through the TARCian Alumni Association suggestion box.
			`;

			await sendEmail('New feedback received', emailContent);

			message.success('Message sent successfully!');
			form.resetFields();
		} catch (error) {
			message.error('Failed to send message. Please try again.');
			console.error('Error sending message:', error);
		} finally {
			setLoading(false);
		}
	};

	const content = (
		<div className={`content-container ${loading ? 'loading' : ''}`}>
			<Spin spinning={loading} indicator={antIcon}>
				<div className="form-container">
					<Title level={4} className="content-title">
						Send Us a Message
					</Title>
					<Form form={form} onFinish={onFinish} layout="vertical" disabled={loading}>
						<Form.Item name="fname" rules={[{ required: true, message: 'Name is required' }]}>
							<Input placeholder="Name" className="content-input" />
						</Form.Item>
						<Form.Item
							name="uemail"
							rules={[
								{ required: true, message: 'Email is required' },
								{ type: 'email', message: 'Please enter a valid email!' },
							]}
						>
							<Input placeholder="Email" type="email" className="content-input" />
						</Form.Item>
						<Form.Item
							name="msg_subject"
							className="content-input"
							rules={[{ required: true, message: 'Subject is required' }]}
						>
							<Input placeholder="Subject" />
						</Form.Item>
						<Form.Item
							name="textarea-172"
							className="content-textarea"
							rules={[{ required: true, message: 'Message is required' }]}
						>
							<TextArea placeholder="Message" rows={6} />
						</Form.Item>
						<Form.Item>
							<Button
								type="primary"
								htmlType="submit"
								className="secondary-button"
								loading={loading}
							>
								Submit
							</Button>
						</Form.Item>
					</Form>
				</div>
			</Spin>
		</div>
	);

	return (
		<div className="suggestion-box-container">
			<Popover
				content={content}
				trigger="click"
				placement="left"
				arrow={false}
				open={popoverOpen}
				onOpenChange={handlePopoverOpenChange}
			>
				<FloatButton icon={<img src={ChatIcon} alt="icon" className="float-button-icon" />} />
			</Popover>
		</div>
	);
};

export default SuggestionBox;
